var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden md:block"},[_c('div',{staticClass:"text-center text-white font-bold text-2xl md:text-4xl"},[_vm._v("\n    "+_vm._s(_vm.$t('cars.hero.slogan'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-white text-center text-sm md:text-xl"},[_vm._v("\n    "+_vm._s(_vm.$t('cars.hero.subtitle'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }